import { createRequestEnumPreprocessor } from '../../../utils/create-request-enum-preprocessor';
import { unitsOfMeasurementOptions } from '../../routing-profile-service/schemas/units-of-measurement.schema';
import { companySettingsSchema } from './company-settings.schema';

export const companySettingsRequestSchema = companySettingsSchema.extend({
  units: createRequestEnumPreprocessor(unitsOfMeasurementOptions),
});
